// Инициализация темы
const urlParams = new URLSearchParams(window.location.search);
const isDarkTheme = urlParams.get('dark') === 'true';
document.documentElement.setAttribute('data-theme', isDarkTheme ? 'dark' : 'light');

// Инициализация Socket.IO
const socket = io(window.location.origin, {
    path: '/socket.io/',
    transports: ['websocket', 'polling'],
    secure: true // если используется HTTPS
});

// Получение ID комнаты из URL
let roomId = window.location.pathname.replace('/', '');
if (!roomId) {
  roomId = 'default-room';
}

// DOM элементы
const usernameSection = document.getElementById('usernameSection');
const chatSection = document.getElementById('chatSection');
const messagesEl = document.getElementById('messages');
const usernameInput = document.getElementById('username');
const usernameForm = document.getElementById('usernameForm');
const joinBtn = document.getElementById('joinBtn');
const leaveBtn = document.getElementById('leaveBtn');
const roomInfoEl = document.getElementById('roomInfo');
const messageForm = document.getElementById('messageForm');
const messageInput = document.getElementById('messageInput');
const emojiBtn = document.getElementById('emojiBtn');
const emojiPicker = document.getElementById('emojiPicker');
const userCountEl = document.getElementById('userCount');

// Обработка эмодзи
emojiBtn.addEventListener('click', () => {
  emojiPicker.classList.toggle('show');
});

document.querySelectorAll('.emoji-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    messageInput.value += btn.textContent;
    emojiPicker.classList.remove('show');
    messageInput.focus();
  });
});

// Закрываем эмодзи пикер при клике вне его
document.addEventListener('click', (e) => {
  if (!e.target.closest('#emojiPicker') && !e.target.closest('#emojiBtn')) {
    emojiPicker.classList.remove('show');
  }
});

roomInfoEl.textContent = `ID комнаты: ${roomId}`;

let username = '';
let isFirstJoin = true;

// Проверяем сохраненное имя пользователя в localStorage
const savedUsername = localStorage.getItem('username');
if (savedUsername) {
  username = savedUsername;
  usernameInput.value = username;
  isFirstJoin = false;
  // Автоматически подключаемся к чату если имя уже сохранено
  socket.emit('joinRoom', { roomId, username });
  usernameSection.classList.add('hidden');
  chatSection.classList.remove('hidden');
}

usernameForm.addEventListener('submit', (e) => {
  e.preventDefault();
  username = usernameInput.value.trim();
  
  // Проверка имени на допустимые символы
  const nameRegex = /^[a-zA-Zа-яА-ЯёЁ0-9\s]{1,20}$/;
  if (!nameRegex.test(username)) {
    alert('Имя может содержать только буквы, цифры и пробелы. Максимум 20 символов.');
    return;
  }

  if (username) {
    // Сохраняем имя пользователя в localStorage
    localStorage.setItem('username', username);
    
    socket.emit('joinRoom', { roomId, username });
    usernameSection.classList.add('hidden');
    chatSection.classList.remove('hidden');
    isFirstJoin = true;
  }
});

leaveBtn.addEventListener('click', () => {
  socket.emit('leaveRoom', { roomId, username });
  localStorage.removeItem('username');
  username = '';
  usernameInput.value = '';
  chatSection.classList.add('hidden');
  usernameSection.classList.remove('hidden');
  messagesEl.innerHTML = '';
  isFirstJoin = true;
});

// Добавим переменные для отслеживания состояния медленного режима
let slowModeDelay = 0;
let lastMessageTime = 0;

// Обновим обработчик отправки сообщения
messageForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const message = messageInput.value.trim();
    
    if (!message) return;

    // Проверяем медленный режим
    if (slowModeDelay > 0) {
        const now = Date.now();
        const timeSinceLastMessage = (now - lastMessageTime) / 1000;
        
        if (timeSinceLastMessage < slowModeDelay) {
            const remainingTime = Math.ceil(slowModeDelay - timeSinceLastMessage);
            showError(`Подождите ${remainingTime} сек. перед отправкой следующего сообщения`);
            return;
        }
    }

    socket.emit('chatMessage', { roomId, message });
    messageInput.value = '';
    lastMessageTime = Date.now();
});

// Обновим обработчик slowModeChanged
socket.on('slowModeChanged', ({ seconds }) => {
    slowModeDelay = seconds;
    if (seconds > 0) {
        const messageForm = document.getElementById('messageForm');
        let indicator = messageForm.querySelector('.slow-mode-indicator');
        if (!indicator) {
            indicator = document.createElement('div');
            indicator.className = 'slow-mode-indicator';
            messageForm.insertBefore(indicator, messageForm.firstChild);
        }
        indicator.textContent = `⏱️ Медленный режим: сообщения раз в ${seconds} секунд`;
    } else {
        const indicator = document.querySelector('.slow-mode-indicator');
        if (indicator) {
            indicator.remove();
        }
    }
});

// Обновим функцию показа уведомлений
function showNotification(message) {
    const notifications = document.getElementById('notifications');
    const notification = document.createElement('div');
    notification.className = 'notification';
    notification.textContent = message;
    
    notifications.appendChild(notification);
    
    // Уведомление автоматически исчезнет благодаря CSS анимации
    setTimeout(() => {
        notification.remove();
    }, 5000);
}

// Обновим обработчик ошибок
socket.on('error', (data) => {
    if (typeof data === 'string') {
        showError(data);
    } else if (data.message) {
        showError(data.message);
    }
});

// Обновим функцию показа ошибок
function showError(message) {
    const notifications = document.getElementById('notifications');
    const errorDiv = document.createElement('div');
    errorDiv.className = 'error-message';
    errorDiv.textContent = message;
    
    notifications.appendChild(errorDiv);
    
    setTimeout(() => {
        errorDiv.remove();
    }, 3000);
}

// Добавляем функцию для генерации цвета из строки
function stringToColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF;
        color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
}

function addMessage(text, type = 'user', messageId = null) {
    const el = document.createElement('div');
    if (messageId) {
        el.id = `message-${messageId}`;
    }
    el.classList.add('py-1', 'px-2', '-mx-2', 'rounded');
    el.style.color = 'var(--text-color)';
    el.style.backgroundColor = 'transparent';
    el.addEventListener('mouseover', () => {
        el.style.backgroundColor = 'var(--input-bg)';
    });
    el.addEventListener('mouseout', () => {
        el.style.backgroundColor = 'transparent';
    });
    const userColor = stringToColor(type === 'user' ? text.split(': ')[0] : text.split(': ')[0]);
    el.innerHTML = `
        <span style="color: ${userColor}; font-weight: bold;">${type === 'user' ? text.split(': ')[0] : text.split(': ')[0]}</span>: ${text.split(': ')[1]}
    `;
    messagesEl.appendChild(el);
    messagesEl.scrollTop = messagesEl.scrollHeight;
}

// Socket.IO event handlers
socket.on('chatMessage', (data) => {
    addMessage(`${data.username}: ${data.message}`, 'user', data.id);
});

socket.on('messageHistory', (messages) => {
    messages.forEach(msg => {
        addMessage(`${msg.username}: ${msg.message}`, 'user', msg.id);
    });
});

socket.on('userCount', (count) => {
  userCountEl.textContent = `${count} ${count === 1 ? 'участник' : count < 5 ? 'участника' : 'участников'}`;
});

// Добавим обработчик события удаления сообщения
socket.on('messageDeleted', (data) => {
    const messageEl = document.getElementById(`message-${data.id}`);
    if (messageEl) {
        messageEl.innerHTML = `<em style="color: var(--text-muted)">${data.message}</em>`;
        messageEl.style.opacity = '0.7';
    }
});

// Функция для проверки, является ли пользователь модератором
const isAdmin = () => {
    // Логика проверки, например, наличие токена или специального флага
    return window.location.pathname.includes('/admin');
};

// При отображении сообщений добавляем кнопку удаления для модераторов
const displayMessage = (message) => {
    const messageElement = document.createElement('div');
    messageElement.textContent = message.text;
    
    if (isAdmin()) {
        const deleteButton = document.createElement('button');
        deleteButton.textContent = 'Удалить';
        deleteButton.onclick = () => deleteMessage(message.id);
        messageElement.appendChild(deleteButton);
    }

    document.getElementById('messages').appendChild(messageElement);
};

// Функция для удаления сообщения
const deleteMessage = async (id) => {
    const room = window.location.pathname.split('/')[1];
    const response = await fetch(`/api/${room}/message/${id}`, {
        method: 'DELETE'
    });
    if (response.ok) {
        // Удалить сообщение из интерфейса
        // Логика обновления интерфейса
    } else {
        alert('Не удалось удалить сообщение');
    }
}; 